<div class="time-cycle-chart-tooltip-container">
  <h3 class="time-cycle-chart-tooltip-title">{{ title }}</h3>

  <div class="time-cycle-chart-tooltip-contents">
    <p class="time-cycle-chart-tooltip-item">
      <span *ngIf="weeks !== undefined && weeks !== 0" class="time-cycle-chart-tooltip-value">
        <span class="time-cycle-chart-tooltip-highlight-value">{{ weeks }} weeks</span>
      </span>
    </p>

    <div *ngIf="badge as statusBadge" class="time-cycle-chart-tooltip-status-item">
      <core-badge
        [color]="statusBadge.textColor"
        [backgroundcolor]="statusBadge.backgroundColor"
        [label]="statusBadge.label"
        [showicon]="false"
      >
      </core-badge>
      <span *ngIf="suffixText" class="time-cycle-chart-tooltip-suffix">{{ suffixText }}</span>
    </div>
  </div>
</div>
